import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserMailChangeRequestBody, UserMailChangeResponse } from "./types";

export class UserMailChangeAPI extends BaseAPI<
  UserMailChangeRequestBody,
  UserMailChangeResponse
> {
  protected route = ApiRoutes.auth.mail_change;
  protected method = RequestMethod.PUT;
}
